import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { EventComponent } from './pages/event/event.component';
import { UserFormComponent } from './pages/order/order.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { UpdateProfileComponent } from './pages/update-profile/update-profile.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsOfSaleComponent } from './pages/terms-of-sale/terms-of-sale.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ProfileMembershipComponent } from './pages/membership/profile-membership/profile-membership.component';
import { MembershipComponent } from './pages/membership/membership.component';
import { BuyMembershipComponent } from './pages/membership/buy-membership/buy-membership.component';
import { BuyMembershipOrderComponent } from './pages/membership/buy-membership-order/buy-membership-order.component';
import { MembershipPaymentComponent } from './pages/membership/membership-payment/membership-payment.component';
import { SeasonTicketComponent } from './pages/season-ticket/season-ticket.component';
import { AdminLoginComponent } from './pages/admin-login/admin-login.component';
import { VotingRightToVoteComponent } from './pages/voting/voting-right-to-vote/voting-right-to-vote.component';

import { VotingVerificationPinComponent } from './pages/voting/voting-verification-pin/voting-verification-pin.component';
import { VotingListComponent } from './pages/voting/voting-list/voting-list.component';
import { VotingFinishComponent } from './pages/voting/voting-finish/voting-finish.component';
import { AuthVotingGuard } from './auth/auth.voting.guard';
import { VotingUploadImageComponent } from './pages/voting/voting-upload-image/voting-upload-image.component';
import { PdfTicketsFromEmailComponent } from './pages/pdf-tickets-from-email/pdf-tickets-from-email.component';
import { AuthConnectionGuard } from './auth/auth.connection.guard';
import { SeasonTicketProfileComponent } from './components/season-ticket-profile/season-ticket-profile.component';
import { ReturnTicketsComponent } from './pages/return-tickets/return-tickets.component';
import { MyCardsComponent } from './pages/my-cards/my-cards.component';
import {PricesComponent} from "./pages/prices/prices.component";

export const routes: Routes = [
  {path: '', component: HomepageComponent},
  {path: `event/:connId/:eventId/:actionId/:hashedId`, component: EventComponent},
  {path: `event/:connId/:eventId/:actionId/:hashedId/transactionIncompleted`, component: EventComponent, canActivate:[AuthGuard]},
  {path: `event/:connId/:eventId/:actionId/:hashedId/transactionExpired`, component: EventComponent, canActivate:[AuthGuard]},
  {
    path: 'user-profile',
    canActivate:[AuthGuard],
    children: [
      { path: '', component: UserProfileComponent },
      { path: 'transactionCompleted', component: UserProfileComponent },
      { path: 'transactionIncompleted', component: UserProfileComponent },
    ]
  },
  {path: 'order/:connId/:eventId/:orderId/:actionId/:hashedId', component: UserFormComponent, canActivate:[AuthGuard]},
  {path: 'registration', component: RegistrationComponent},
  {path: 'update-profile', component: UpdateProfileComponent, canActivate:[AuthGuard]},
  {path: 'change-password', component: ChangePasswordComponent, canActivate:[AuthGuard]},
  {
    path: 'membership-profile',
    canActivate:[AuthGuard],
    children: [
      { path: '', component: ProfileMembershipComponent },
      { path: 'transactionCompleted', component: ProfileMembershipComponent },
      { path: 'transactionIncompleted', component: ProfileMembershipComponent },
    ]
  },
  {path: 'membership-profile-others', component: ProfileMembershipComponent, canActivate:[AuthGuard]},
  {path: 'club-friends-profile', component: ProfileMembershipComponent, canActivate:[AuthGuard]},
  //{path: 'membership', component: MembershipComponent, canActivate:[AuthConnectionGuard]},
  {path: 'membership', component: MembershipComponent},
  {path: 'season-tickets-profile', component: SeasonTicketProfileComponent, canActivate:[AuthGuard]},
  {
    path: 'group-tickets-profile',
    canActivate:[AuthGuard],
    children: [
      { path: '', component: SeasonTicketProfileComponent },
      { path: 'transactionCompleted', component: SeasonTicketProfileComponent },
      { path: 'transactionIncompleted', component: SeasonTicketProfileComponent },
    ]
  },
  {path: 'buy-membership', component: BuyMembershipComponent},
  {path: 'privacy-policy', pathMatch: 'full', redirectTo: 'terms-of-sale'},
  {path: 'terms-of-sale', component: TermsOfSaleComponent},
  {path: 'not-found', component: NotFoundComponent},
  {path: 'buy-membership/:orderId', component: BuyMembershipOrderComponent, canActivate:[AuthGuard]},
  {path: 'buy-membership/cart/:orderId', component: MembershipPaymentComponent, canActivate:[AuthGuard]},
  {path: 'buy-season-ticket/cart/:orderId', component: MembershipPaymentComponent, canActivate:[AuthGuard]},
  {path: 'buy-season-ticket/:eventId/:actionId', component: SeasonTicketComponent},
  {path: 'ws', component: AdminLoginComponent},
  {path: 'izbori', component: VotingRightToVoteComponent, canActivate:[AuthConnectionGuard]},
  {path: 'izbori/verifikacija', component: VotingVerificationPinComponent, canActivate:[AuthVotingGuard, AuthConnectionGuard]},
  {path: 'izbori/upload-oi', component: VotingUploadImageComponent, canActivate:[AuthVotingGuard, AuthConnectionGuard]},
  {path: 'izbori/lista', component: VotingListComponent, canActivate:[AuthVotingGuard, AuthConnectionGuard]},
  {path: 'izbori/finish', component: VotingFinishComponent, canActivate:[AuthVotingGuard, AuthConnectionGuard]},
  {path: 'pdf-tickets-from-email', component: PdfTicketsFromEmailComponent},
  {path: 'pdf-tickets-delegation-from-email', component: PdfTicketsFromEmailComponent},
  {path: 'ustupi-ulaznicu', component: ReturnTicketsComponent},
  {
    path: 'transfer-tickets',
    canActivate:[AuthGuard],
    children: [
      { path: '', component: ReturnTicketsComponent },
      { path: 'transactionCompleted', component: ReturnTicketsComponent },
      { path: 'transactionIncompleted', component: ReturnTicketsComponent },
    ]
  },
  {path: 'my-cards', component: MyCardsComponent, canActivate:[AuthGuard]},
  {
    path: 'prices',
    loadComponent: () =>
      import('./pages/prices/prices.component').then(c => c.PricesComponent)
  },
  {path: '**', redirectTo: ''},
  /* {path: ':number', component: NotFoundComponent}, */
];
